import { useEffect, useState, useMemo } from "react";
import Loading from "../../Loading";
import { useAuth } from "../../../context/AuthContext";
import axios from "axios";
import {useTableManager} from "../../hooks/useTableManager";

const SEARCH_KEYS = ['fileName', 'batchType', 'status', 'userEmail'];
function BatchQueue() {
    const formData = new FormData();
    var results = null;
    const [loading, setLoading] = useState(true);
    const [batchList, setBatchList] = useState([]);
    const { email, token, roles } = useAuth();
    const isAdmin = roles.includes("cdlisAdmin");
    const {
        searchTerm, setSearchTerm,
        requestSort, getSortIndicator,
        currentPage, setCurrentPage, handleNextPage, handlePrevPage,
        itemsPerPage, setItemsPerPage,
        currentData, totalItems, totalPages, startIndex
    } = useTableManager(batchList, SEARCH_KEYS, 'completionDate', 'desc');

    useEffect(() => {
        const url = isAdmin ? "/api/user/batchUpload/all" : `/api/user/batchUpload/userEmail/${email}`;
        const fetchBatchStatuses = async () => {
        await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      .then(response => response.json())
      .then(data => {
        setBatchList(data.batchRecords || []);
        setLoading(false);
      }) 
      .catch(error => {
        console.error('Error fetching batch IDs:', error);
      });
        }
        fetchBatchStatuses();
      }, [email, isAdmin, token]);
    const triggerDownload = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const downloadOneFile = async (url, filename) => {
    if (!url) return;

    const res = await fetch(`/api/batch/download?url=${url}`, {
    // const res = await fetch(`/api/batch/download?submissionId=${url}`, {
    //const res = await fetch(url, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
      
    });

    if (!res.ok) {
      console.error(`Failed to fetch ${filename}`, res.status);
      return;
    }

    const blob = await res.blob();
    triggerDownload(blob, filename);
  };

  const downloadBatch = async (id) => {
    try {
      const res = await fetch(`/api/batch/download?submissionId=${id}`, {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
      });

      const response = await res.json();

      if (!response.successUrl && !response.errorUrl) {
        alert(response?.error?.meta || 'No download URLs available yet.');
        return;
      }

      const { successUrl, errorUrl } = response;

      console.log("success: "+successUrl);
      console.log("error: " + errorUrl);

      await downloadOneFile(successUrl, `batch-${id}-success.csv`);
      await downloadOneFile(errorUrl,  `batch-${id}-error.csv`);
    } catch (err) {
      console.error(`Download failed for ${id}`, err);
      alert('Download failed. Please contact Helpdesk.');
    }
  };

    // Send the file to your server using fetch or another method
    if(loading){
        return(<>
            <Loading />
            </>)  
    }
    return(
        <div id='table'>
            <div id="banner-results">
              {isAdmin ? <h4>Batch Queue for All Users</h4> : <h4>Batch Queue for {email}</h4>}
            </div>
            {/* Controls Row */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              {isAdmin && (
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search by file name, status, or email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ maxWidth: "400px", margin: "10px"}}
                />
              )}
                
                <div className="d-flex align-items-center">
                    <label className="me-2 mb-0">Items per page:</label>
                    <select 
                        className="form-select" 
                        value={itemsPerPage} 
                        onChange={(e) => setItemsPerPage(Number(e.target.value))}
                        style={{ width: "auto" }}
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>
            </div>
            <table className="table table-striped table-bordered">
                <thead className="table-header">
                  <tr>
                      <th scope="col">Download</th>
                      {/* NEW: Clickable Headers for Sorting */}
                      <th scope="col" onClick={() => requestSort('fileName')} style={{ cursor: 'pointer' }}>
                          File Name {getSortIndicator('fileName')}
                      </th>
                      <th scope="col" onClick={() => requestSort('uploadDate')} style={{ cursor: 'pointer' }}>
                          Upload Date {getSortIndicator('uploadDate')}
                      </th>
                      <th scope="col" onClick={() => requestSort('batchType')} style={{ cursor: 'pointer' }}>
                          Batch Type {getSortIndicator('batchType')}
                      </th>
                      <th scope="col" onClick={() => requestSort('status')} style={{ cursor: 'pointer' }}>
                          Process Status {getSortIndicator('status')}
                      </th>
                      <th scope="col" onClick={() => requestSort('completionDate')} style={{ cursor: 'pointer' }}>
                          Date Completed {getSortIndicator('completionDate')}
                      </th>
                      {isAdmin && (
                          <th scope="col" onClick={() => requestSort('userEmail')} style={{ cursor: 'pointer' }}>
                              User Email {getSortIndicator('userEmail')}
                          </th>
                      )}
                  </tr>
                </thead>
                <tbody>
                    {currentData.map((details, index) => (
                        <tr key={details.submissionId || index}>
                            <td>
                              {details?.status?.includes('COMPLETE') ?
                                <button className="btn btn-success"
                                    onClick={() => downloadBatch(details.submissionId)}>
                                        Download Batch Results
                                </button> :
                                <button className="btn btn-outline-secondary" disabled>
                                  Waiting on Results
                                </button>
                              }
                            </td>
                            <td>{details.fileName}</td>
                            <td>{details.uploadDate}</td>
                            <td>{details.batchType}</td>
                            <td>{details.status}</td>
                            <td>{details.completionDate}</td>
                            {isAdmin && (<td>{details.userEmail}</td>)}
                        </tr>
                    ))}
                    {currentData.length === 0 && (
                        <tr>
                            <td colSpan={isAdmin ? 7 : 6} className="text-center">
                                No records found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            {currentData.length > 0 && (
              <div className="d-flex justify-content-between align-items-center mt-3">
                  <div>
                    Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, totalItems)} of {totalItems} entries
                  </div>
                  <div>
                      <button 
                          className="btn btn-outline-primary me-2" 
                          onClick={handlePrevPage} 
                          disabled={currentPage === 1}
                      >
                          Previous
                      </button>
                      <span className="me-2">Page {currentPage} of {totalPages}</span>
                      <button 
                          className="btn btn-outline-primary" 
                          onClick={handleNextPage} 
                          disabled={currentPage === totalPages}
                      >
                          Next
                      </button>
                  </div>
              </div>
            )}
        </div>
        
    )
}

export default BatchQueue;